"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FullscreenPortal = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const ui_react_1 = require("@streem/ui-react");
const react_1 = require("react");
const react_dom_1 = require("react-dom");
const FullscreenPortal = ({ children, className }) => {
    const domNode = (0, react_1.useRef)(document.createElement('div'));
    (0, react_1.useEffect)(() => {
        const child = domNode.current;
        document.body.appendChild(child);
        return () => {
            document.body.removeChild(child);
        };
    }, [domNode]);
    (0, react_1.useEffect)(() => {
        domNode.current.className = className;
    }, [domNode, className]);
    return (0, react_dom_1.createPortal)((0, jsx_runtime_1.jsx)("div", Object.assign({ style: {
            position: 'absolute',
            zIndex: ui_react_1.Theme.layers.callFrame,
            bottom: 0,
            left: 0,
            right: 0,
        }, "data-testid": "full-screen-portal" }, { children: children })), domNode.current);
};
exports.FullscreenPortal = FullscreenPortal;
//# sourceMappingURL=fullscreen_portal.js.map